import React, { useEffect, useState } from 'react';
import { getGroupsAPI } from '../../../api/protocolGroups';
import { ModalSpinner } from '../../../components/Utils/Loaders';
import GroupDetailContainer from './GroupDetailContainer';
import GroupListContainer from '../Groups/GroupListContainer';
import Card from '../../../components/Cards/Card';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

const ProtocolScopedGroupsContainer = ({ protocolId }) => {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGroups, setIsLoadingGroups] = useState(true);

    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 50,
            totalSize: 0
        },
        sort: {
            sortField: 'Start',
            sortOrder: 'desc'
        },
        filters: {
            protocolIds: null,
        }
    });

    useEffect(() => {
        if (!protocolId) return;
        setSelectedGroup(null);
        setIsLoadingGroups(true);
        setQuery((q) => ({
            ...q,
            filters: { ...q.filters, protocolIds: protocolId }
        }));
    }, [protocolId]);

    useEffect(() => {
        if (!query.filters.protocolIds) return;

        const fetchData = async () => {
            try {
                const response = await getGroupsAPI(query);
                setGroups(response.data?.data || []);
            } catch (error) {
                HandleApiError(error);
            } finally {
                setIsLoadingGroups(false);
            }
        };

        fetchData();
    }, [query]);

    const handleUpdateGroup = async () => {
        try {
            setIsLoading(true);
            const response = await getGroupsAPI(query);
            const refreshedGroups = response.data?.data || [];
            setGroups(refreshedGroups);
            if (selectedGroup) {
                const refreshedGroup = refreshedGroups.find(g => g.id === selectedGroup.id);
                setSelectedGroup(refreshedGroup);
            }
        } catch (error) {
            console.error('Error al refrescar el grupo:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const protocolContext = { protocolId };

    if (isLoading) {
        return <ModalSpinner isShowing={true} />;
    }

    return (
        <div className="p-4">
            {!selectedGroup ? (
                <Card
                    content={
                        <GroupListContainer
                            groups={groups}
                            onSelect={setSelectedGroup}
                            isLoading={isLoadingGroups}
                        />
                    }
                />
            ) : (
                <GroupDetailContainer
                    group={selectedGroup}
                    onBack={() => setSelectedGroup(null)}
                    updateGroup={handleUpdateGroup}
                    protocolId={protocolContext}
                />
            )}
        </div>
    );
};

export default ProtocolScopedGroupsContainer;
